/** PDF viewer functions **/
if (document.body.classList.contains('page-template-annual-report')) {
    let pdfViewer = document.getElementById('pdf-viewer');

    window.addEventListener('click', function (event) {
        let target = event.target;

        if (!pdfViewer.contains(target)) {
            goToFirstPage();
        } else {
            if (checkPage() != 1) {
                pdfViewer.scrollIntoView({ behavior: 'smooth' });
            }
        }

        checkFirstPage();
    });

    pdfViewer.addEventListener('dblclick', function () {
        fullScreen();
    });

    let fullScreenButton = document.querySelector('.pdf-fullscreen-button');
    fullScreenButton.addEventListener('click', function () {
        fullScreen();
    });

    let closeButton = document.querySelector('.pdf-close-button');
    closeButton.addEventListener('click', function () {
        goToFirstPage();
        checkFirstPage();
    });

};

function checkPage() {
    let page;

    if (window.df_172) {
        //page = window.df_172.target._activePage;
        page = window.df_172.target.currentPageNumber;
    } else if (window.df_862) {
        //page = window.df_862.target._activePage;
        page = window.df_862.target.currentPageNumber;
    } else if (window.df_857) {
        //page = window.df_857.target._activePage;
        page = window.df_857.target.currentPageNumber;
    } else {
        page = null;
    }
    return page;
}

function checkFirstPage() {
    let page = checkPage();

    let pdfViewer = document.getElementById('pdf-viewer');
    let annualReport = document.getElementById('annual-report');
    let uiNext = document.querySelector('.df-container.df-float>.df-ui-next');

    if (page > 1) {
        pdfViewer.classList.add('double-position');
        annualReport.classList.add('opacity-0');
        uiNext.classList.add('move-ui-next');
    } else {
        pdfViewer.classList.remove('double-position');
        annualReport.classList.remove('opacity-0');
        uiNext.classList.remove('move-ui-next');
    }
}

function fullScreen() {
    let toggleFullScreen = document.querySelector('.df-ui-btn[title="Toggle Fullscreen"]');
    toggleFullScreen.click();
}

function goToFirstPage() {
    let gotoFirstPageButton = document.querySelector('.df-ui-btn.df-ui-start[title="Goto First Page"]');

    if (gotoFirstPageButton) {
        gotoFirstPageButton.click();
    }
}